import type { SanctionClause } from '~hooks/queries/clauses/types'

export const mockSanctionClauses: SanctionClause[] = [
  {
    _id: '1',
    type: 'sanctions',
    title: '1. Russia Sanctions Overview',
    answer: `<p>This section outlines the general framework for Russia-related sanctions applicable to vessel trading operations.</p>
<p>Key points:</p>
<ul>
  <li>All trading activities must comply with EU, UK, and US sanctions regulations</li>
  <li>Vessels must not call at Russian ports without prior written approval</li>
  <li>All counterparties must be screened against sanctions lists</li>
</ul>`,
    order: 1,
    createdAt: '2024-01-15T10:00:00.000Z',
    createdBy: { name: 'Legal Team', email: 'legal@maersktankers.com' },
  },
  {
    _id: '2',
    type: 'sanctions',
    title: '2. G7 Price Cap Compliance',
    answer: `<p>The G7 price cap mechanism restricts the price at which Russian-origin crude oil and petroleum products can be traded.</p>
<p><strong>Current Price Caps:</strong></p>
<ul>
  <li>Crude oil: $60 per barrel</li>
  <li>Premium petroleum products (diesel, gasoline): $100 per barrel</li>
  <li>Discounted petroleum products (fuel oil, naphtha): $45 per barrel</li>
</ul>
<p>All charterers must provide attestations confirming price cap compliance before fixture confirmation.</p>`,
    order: 2,
    createdAt: '2024-01-15T10:00:00.000Z',
    createdBy: { name: 'Legal Team', email: 'legal@maersktankers.com' },
  },
  {
    _id: '3',
    type: 'sanctions',
    title: '3. Vessel Trading Restrictions',
    answer: `<p>The following trading restrictions apply to all vessels:</p>
<h3>Prohibited Activities:</h3>
<ul>
  <li>Direct calls to Russian ports (Baltic, Black Sea, Arctic)</li>
  <li>Ship-to-ship transfers with vessels carrying Russian-origin cargo</li>
  <li>Transporting cargo for sanctioned entities</li>
</ul>
<h3>Required Documentation:</h3>
<ul>
  <li>Certificate of origin for all cargo</li>
  <li>Sanctions compliance attestation from charterers</li>
  <li>End-user declarations where applicable</li>
</ul>`,
    order: 3,
    createdAt: '2024-01-15T10:00:00.000Z',
    createdBy: { name: 'Legal Team', email: 'legal@maersktankers.com' },
  },
  {
    _id: '4',
    type: 'sanctions',
    title: '4. Iran Sanctions',
    answer: `<p>Complete prohibition on all trade activities involving Iranian entities, vessels, or cargo.</p>
<p><strong>This includes:</strong></p>
<ul>
  <li>No calling at Iranian ports</li>
  <li>No loading/discharging Iranian-origin cargo</li>
  <li>No engagement with Iranian-owned or controlled vessels</li>
  <li>No ship-to-ship transfers in Iranian waters</li>
</ul>
<p>Any suspected Iranian connection must be reported immediately to the Legal department.</p>`,
    order: 4,
    createdAt: '2024-01-15T10:00:00.000Z',
    createdBy: { name: 'Legal Team', email: 'legal@maersktankers.com' },
  },
  {
    _id: '5',
    type: 'sanctions',
    title: '5. North Korea Sanctions',
    answer: `<p>Comprehensive sanctions apply to all trade with North Korea (DPRK).</p>
<p>Absolutely prohibited:</p>
<ul>
  <li>Any port calls in North Korea</li>
  <li>Ship-to-ship transfers with DPRK-flagged vessels</li>
  <li>Transporting any cargo to or from North Korea</li>
  <li>Any financial transactions involving DPRK entities</li>
</ul>`,
    order: 5,
    createdAt: '2024-01-15T10:00:00.000Z',
    createdBy: { name: 'Legal Team', email: 'legal@maersktankers.com' },
  },
  {
    _id: '6',
    type: 'sanctions',
    title: '6. Venezuela Sanctions',
    answer: `<p>Sanctions restrictions apply to Venezuelan oil sector activities.</p>
<p><strong>Current Status:</strong></p>
<ul>
  <li>Trading Venezuelan-origin petroleum requires specific OFAC licenses</li>
  <li>PdVSA and subsidiaries remain on SDN list</li>
  <li>All Venezuelan trades require prior Legal approval</li>
</ul>
<p>Contact Legal before engaging in any Venezuela-related trading activity.</p>`,
    order: 6,
    createdAt: '2024-01-15T10:00:00.000Z',
    createdBy: { name: 'Legal Team', email: 'legal@maersktankers.com' },
  },
  {
    _id: '7',
    type: 'sanctions',
    title: '7. Sanctions Screening Requirements',
    answer: `<p>All counterparties must be screened before entering into any commercial arrangement.</p>
<h3>Screening Process:</h3>
<ol>
  <li>Submit counterparty details to Compliance team</li>
  <li>Screening against OFAC, EU, UN, and UK sanctions lists</li>
  <li>Beneficial ownership verification</li>
  <li>Approval or rejection within 24 hours</li>
</ol>
<p>No fixture can be confirmed without completed sanctions screening.</p>`,
    order: 7,
    createdAt: '2024-01-15T10:00:00.000Z',
    createdBy: { name: 'Legal Team', email: 'legal@maersktankers.com' },
  },
  {
    _id: '8',
    type: 'sanctions',
    title: '8. Ship-to-Ship Transfer Guidelines',
    answer: `<p>Ship-to-ship (STS) transfers require additional scrutiny due to sanctions evasion risks.</p>
<h3>Required Checks:</h3>
<ul>
  <li>Verify identity of STS partner vessel</li>
  <li>Confirm cargo origin documentation</li>
  <li>Check vessel's recent port call history</li>
  <li>Obtain charterer attestation on cargo origin</li>
</ul>
<h3>Red Flags:</h3>
<ul>
  <li>AIS gaps or manipulation</li>
  <li>Recent calls to sanctioned ports</li>
  <li>Opaque ownership structures</li>
</ul>`,
    order: 8,
    createdAt: '2024-01-15T10:00:00.000Z',
    createdBy: { name: 'Legal Team', email: 'legal@maersktankers.com' },
  },
]
